import { setCookie, getCookie } from './cookie';
const  { getFingerPrintId } = require('./fingerprint');

class ScTrack {
    constructor() {
        this.instance = null;
        this.trackInstance = null;
        this.fingerprintId = '';

        this.init();
    }

    static getInstance(options = {}) {
        if (!this.instance) {
            this.instance = new ScTrack(options);
        }
        return this.instance;
    }

    async getComputerId() {
        this.fingerprintId = await getFingerPrintId();
    }


    async init() {
        await this.getComputerId();
        if (!jftrack) return;
        this.trackInstance = new jftrack({
            debugger: process.env.NODE_ENV !== 'production',
            server_url: 'https://jc-sensors.9fapi.com/sa',
            userName: this.fingerprintId || '9fztgw',
            platForm: '9fztgw',
            project:
                process.env.NODE_ENV !== 'production'
                    ? 'rjhy_huntianling_test'
                    : 'ytx_xinlanghuixuangu',
        });
    }

    track(eventName, props = {}) {
        const trackFn = () => {
            if (!this.trackInstance) return;
            this.trackInstance.track(
                eventName,
                Object.assign(
                    {
                        server_id: 200,
                        platform_id: '9fztgw',
                        front_type: 'wap',
                        project_id: 'ytx_jfztgw',
                        computer_id: this.fingerprintId,
                    },
                    props,
                ),
            );
        }
        // 获取指纹是个异步，trackInstance还没值
        if (!this.trackInstance) {
            setTimeout(() => {
                trackFn();
            }, 500);
        } else {
            trackFn();
        }
    }

    // getFingerprintId() {
    //     let fingerprintId = getCookie('fingerprintId');
    //     if (!fingerprintId) {
    //         fingerprintId = +new Date() + randomString(4);
    //     }
    //     setCookie('fingerprintId', fingerprintId, 7);
    //     this.fingerprintId = fingerprintId;
    // }
}

export default ScTrack;
